import DateRange from 'shared/components/TimePicker/DateRange'
import styles from '../styles.module.scss'

const DateSelection = ({ onDateInputChange }) => (
    <>
        <p>
            <T>booking.event.date.range</T>
        </p>
        <div className={styles.eventsDateRange}>
            <DateRange
                clear
                onChange={onDateInputChange}
                startOptions={{
                    label: <T>events.search.modal.date.range.start</T>,
                }}
                endOptions={{
                    label: <T>events.search.modal.date.range.end</T>,
                }}
            />
        </div>
    </>
)

export default DateSelection
